import { RequestPartnerMaterialUploadRequestSchema, RequestPartnerMaterialUploadResponseSchema } from './request-partner-material-upload.schema';
export const requestPartnerMaterialUploadContract = {
    method: 'POST',
    path: '/api/v2/admin/partner-materials/:id/files/:locale/upload-url',
    description: 'Get a presigned POST for the file of one language',
    requestSchema: RequestPartnerMaterialUploadRequestSchema,
    responseSchema: RequestPartnerMaterialUploadResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner material not found'
        }
    }
};

//# sourceMappingURL=request-partner-material-upload.contract.js.map